import { UserInfo } from "../models/user-info";
import ActivityIndicator from "./ActivityIndicator";
import Header from "./Header";

type LayoutProps = {
  userInfo: UserInfo;
  hideNavigationLinks?: boolean;
  children?: React.ReactNode;
  loading?: boolean;
  className?: string;
};

export const Layout = ({
  userInfo,
  hideNavigationLinks = false,
  children,
  loading = false,
  className,
}: LayoutProps) => {
  return (
    <div className={className}>
      <Header userInfo={userInfo} hideNavigationLinks={hideNavigationLinks} />
      <div className="pb-10">
        {loading && <ActivityIndicator overlay />}
        {children}
      </div>
    </div>
  );
};
